/**
 * InvalidPromosSection Component
 * Displays list of invalid promos
 * UI matches checkout lama InvalidPromoInfoList exactly
 */

import { CardPromoInfo } from '@diamond/shared/ui';

import type { InvalidPromosSectionProps } from './types';

/**
 * Check if there are any invalid promos
 */
function hasInvalidPromo(invalidPromos: any): boolean {
  if (!invalidPromos) return false;

  return (
    invalidPromos.hasDiscount ||
    invalidPromos.hasFreeGoods ||
    invalidPromos.hasCashback ||
    invalidPromos.hasBundledCashback ||
    invalidPromos.hasBundledDiscount ||
    invalidPromos.hasBundledFreeGoods
  );
}

export function InvalidPromosSection({
  invalidPromos,
}: InvalidPromosSectionProps) {
  if (!hasInvalidPromo(invalidPromos)) return null;

  const {
    discount,
    bundledDiscount,
    cashback,
    bundledCashback,
    freeGoods,
    bundledFreeGoods,
    hasFreeGoods,
    hasBundledFreeGoods,
    hasDiscount,
    hasBundledDiscount,
    hasCashback,
    hasBundledCashback,
  } = invalidPromos;

  return (
    <>
      {hasFreeGoods
        ? freeGoods.map((d: any) => (
            <CardPromoInfo
              key={d.promoId}
              type="free-item"
              duration={d.duration}
              text={d.text}
              item={d.item}
              isInvalid
            />
          ))
        : null}
      {hasBundledFreeGoods
        ? bundledFreeGoods.map((d: any) => (
            <CardPromoInfo
              key={d.promoId}
              type="free-item"
              duration={d.duration}
              text={d.text}
              item={d.item}
              isInvalid
            />
          ))
        : null}
      {hasDiscount
        ? discount.map((d: any) => (
            <CardPromoInfo
              key={d.promoId}
              type="discount"
              duration={d.duration}
              text={d.text}
              isInvalid
            />
          ))
        : null}
      {hasBundledDiscount
        ? bundledDiscount.map((d: any) => (
            <CardPromoInfo
              key={d.promoId}
              type="discount"
              duration={d.duration}
              text={d.text}
              isInvalid
            />
          ))
        : null}
      {hasCashback
        ? cashback.map((d: any) => (
            <CardPromoInfo
              key={d.promoId}
              type="cashback"
              duration={d.duration}
              text={d.text}
              isInvalid
            />
          ))
        : null}
      {hasBundledCashback
        ? bundledCashback.map((d: any) => (
            <CardPromoInfo
              key={d.promoId}
              type="cashback"
              duration={d.duration}
              text={d.text}
              isInvalid
            />
          ))
        : null}
    </>
  );
}
